import { html } from '@design.estate/dees-element';
import '../elements/index.js';

export const szDemoApp = () => html`
  <style>
    html, body {
      margin: 0;
      padding: 0;
      height: 100%;
      width: 100%;
      overflow: hidden;
    }
    sz-demo-app-shell {
      display: block;
      height: 100vh;
      width: 100vw;
    }
  </style>
  <sz-demo-app-shell></sz-demo-app-shell>
`;
